'use client';

import * as React from 'react';
import { type Table } from '@tanstack/react-table';
import { RefreshCw, Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Product } from '@tagadapay/crm-entities';
import { ShopifySyncProductButton, SyncDynamicSellingPlansButton } from '@/components/products';
import { BulkUpdateProductsModal } from './bulk-update-products-modal';

interface ProductsTableActionsProps {
  table: Table<Product.Product>;
  onRefresh: () => void;
  isLoading: boolean;
  storeId: string;
}

/**
 * ProductsTableActions component for table toolbar actions
 */
export function ProductsTableActions({ table, onRefresh, isLoading, storeId }: ProductsTableActionsProps) {
  const [showBulkUpdate, setShowBulkUpdate] = React.useState(false);

  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
        <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        Refresh
      </Button>
      <Button variant="outline" size="sm" onClick={() => setShowBulkUpdate(true)} className="h-8">
        <Pencil className="mr-2 h-4 w-4" />
        Bulk Update
      </Button>
      <ShopifySyncProductButton storeId={storeId} onSyncComplete={onRefresh} />
      <SyncDynamicSellingPlansButton storeId={storeId} onSyncComplete={onRefresh} />
      <BulkUpdateProductsModal
        open={showBulkUpdate}
        onOpenChange={setShowBulkUpdate}
        storeId={storeId}
      />
    </div>
  );
}
